




import Vue from "vue";

export default Vue.extend({
  name: "RouteLayout",
  inheritAttrs: false
  // errorCaptured(err: any) {
  //   if (process.env.NODE_ENV === "development") {
  //     console.error(err);
  //   }
  //   return false;
  // }
});
